// extracted by mini-css-extract-plugin
export default {"section":"CTASection_section__ZyTXQ","inner":"CTASection_inner__61cUl","title":"CTASection_title__y4KTs","subtitle":"CTASection_subtitle__z5Pf4","ctas":"CTASection_ctas__Cnarf"};